import { axios } from '../../../axios';

const getMyPropertiesApi = () => {
  return axios.get('/properties/me')
}

const deleteMyPropertiesApi = (id) => {
  return axios.delete(`/properties/${id}`).then(res=>{
    return res;
  }).catch(err=>{
    return err;
  })
}

const signupApi = (data) => {
  return axios.post('/users/auth/register', data)
}
const forgetPasswordFunction = (data) => {
  return axios.post('/users/auth/forget-password', data)
}
const sendOtpApi = (data) => {
  return axios.post('/users/auth/send-otp', data)
}

const verifyOtpApi = (data) => {
  console.log(data)
  return axios.post('/users/auth/verify-otp', data)
}
const resetPasswordApi = (data) => {
  return axios.post('/users/auth/reset-password', data)
}

export { getMyPropertiesApi, signupApi, forgetPasswordFunction, sendOtpApi, resetPasswordApi, verifyOtpApi, deleteMyPropertiesApi }